import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const parkingTypeApi = createApi({
  reducerPath: 'parkingTypeApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingType'],
  endpoints: (builder) => ({
    getParkingTypeData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingTypeController.getParkingTypeData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveParkingType: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingTypeController.saveParkingType,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateParkingType: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingTypeController.updateParkingType,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteParkingType: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingTypeController.deleteParkingType}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    uploadImage: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingTypeController.uploadImage,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetParkingTypeDataMutation,
  useSaveParkingTypeMutation,
  useDeleteParkingTypeMutation,
  useUploadImageMutation,
  useUpdateParkingTypeMutation,
} = parkingTypeApi;
